@if (siteFormGroup && country && LocalizationInfo) {
  <div class="container-fluid px-0">
    <div class="row" [formGroup]="siteFormGroup">
      <div class="col">
        <app-display-card [panelHeight]="'fill'">
          <div class="inner-panel rounded">
            <div class="row">
              <div class="col-12 col-lg-6">
                <div class="site-section-head">
                  <h3 class="mb-0">Site details</h3>
                </div>
                <div class="row g-3">
                  <div class="col-md-7">
                    <label for="siteKey" class="form-label" requiredAsterisk>
                      Site key
                    </label>
                    <input
                      type="text"
                      class="form-control"
                      id="siteKey"
                      formControlName="siteKey"
                    />
                  </div>
                  <div class="col-md-6">
                    <label for="legalName" class="form-label" requiredAsterisk>
                      Legal name
                    </label>
                    <input
                      type="text"
                      class="form-control"
                      id="legalName"
                      formControlName="legalName"
                    />
                  </div>
                  <div class="col-md-6">
                    <label for="dba" class="form-label">DBA</label>
                    <input
                      type="text"
                      class="form-control"
                      id="dba"
                      formControlName="dba"
                    />
                  </div>
                  @if (this.country === 'US') {
                    <div class="col-md-6">
                      <label for="ein" class="form-label" requiredAsterisk>
                        {{ LocalizationInfo.taxId('ein').label }} (Tax ID #)
                      </label>
                      <input
                        type="text"
                        class="form-control"
                        id="ein"
                        placeholder="__-_______"
                        [inputMask]="einMask"
                        formControlName="ein"
                      />
                    </div>
                  }
                  @if (this.country === 'CA') {
                    <div class="col-md-6">
                      <label for="ein" class="form-label">
                        {{ LocalizationInfo.taxId('gst-hst').label }} (Tax ID #)
                      </label>
                      <input
                        type="text"
                        class="form-control"
                        id="ein"
                        placeholder="__-_______"
                        [inputMask]="einMask"
                        formControlName="ein"
                      />
                    </div>
                  }
                  <div class="col-md-10">
                    <label for="phone" class="form-label" requiredAsterisk>
                      Phone
                    </label>
                    <input
                      type="text"
                      class="form-control"
                      id="phone"
                      placeholder="(___) ___-____"
                      [inputMask]="phoneMask"
                      formControlName="phone"
                    />
                  </div>
                  <div class="col-md-2">
                    <label for="ext" class="form-label">Ext.</label>
                    <input
                      type="text"
                      class="form-control"
                      id="ext"
                      formControlName="phoneExt"
                    />
                  </div>
                  <div class="col-md-6">
                    <label for="fax" class="form-label">Fax</label>
                    <input
                      type="text"
                      class="form-control"
                      id="fax"
                      formControlName="fax"
                    />
                  </div>
                  <div class="col-md-6">
                    <label for="units" class="form-label"># of units</label>
                    <input
                      type="text"
                      class="form-control"
                      id="units"
                      formControlName="units"
                    />
                  </div>
                </div>
              </div>
              @if (siteFormGroup) {
                <div class="col-12 col-lg-6">
                  <div class="site-section-head">
                    <h3 class="mb-0">Street address</h3>
                  </div>
                  <app-address-form
                    [addressForm]="siteFormGroup.controls.StreetAddress"
                    [isStreet]="true"
                    [country]="country"
                  ></app-address-form>
                </div>
              }
            </div>
          </div>
        </app-display-card>
      </div>
    </div>

    <div class="row mt-3">
      <div class="col">
        <div class="action-row justify-end">
          <button type="button" class="btn btn-ghost" (click)="back()">
            Back
          </button>
          <button type="button" class="btn btn-primary" (click)="saveSite()">
            Save site
          </button>
        </div>
      </div>
    </div>
  </div>
}
